import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { BookOpen, Users, Briefcase, Zap, MessageSquare, Globe } from 'lucide-react';
export function Programming() {
  const programs = [{
    icon: <BookOpen className="w-5 h-5" data-id="element-195" />,
    title: 'Founder Intensives',
    description: 'Deep-dive operational workshops focused on structuring for scale and compliance.'
  }, {
    icon: <Users className="w-5 h-5" data-id="element-196" />,
    title: 'Leadership Labs',
    description: 'Executive development for women transitioning from operators to CEOs.'
  }, {
    icon: <Briefcase className="w-5 h-5" data-id="element-197" />,
    title: 'Capital Readiness Sessions',
    description: 'Strategic preparation for debt, equity, and grant funding opportunities.'
  }, {
    icon: <Zap className="w-5 h-5" data-id="element-198" />,
    title: 'Execution Sprints',
    description: 'Time-bound, outcome-focused cohorts implementing specific business infrastructure.'
  }, {
    icon: <MessageSquare className="w-5 h-5" data-id="element-199" />,
    title: 'Strategic Roundtables',
    description: 'Curated discussions with ecosystem leaders, investors, and industry experts.'
  }, {
    icon: <Globe className="w-5 h-5" data-id="element-200" />,
    title: 'Ecosystem Workshops',
    description: 'Collaborative sessions bridging founders and institutional partners.'
  }];
  return <section id="programs" className="py-24 lg:py-40 bg-soft-white relative" data-id="element-201">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-202">
        <FadeIn className="text-center max-w-3xl mx-auto mb-24" data-id="element-203">
          <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-vivid-orange mb-8" data-id="element-204">
            Programming & Implementation
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium leading-[1.05] text-deep-azure mb-6" data-id="element-205">
            Outcome-Driven{' '}
            <em className="italic font-light text-dark-azure" data-id="element-206">
              Founder Programming.
            </em>
          </h2>
          <p className="text-lg text-charcoal-navy/70 italic font-display leading-relaxed" data-id="element-207">
            Implementation over inspiration. Execution over endless information.
          </p>
          <div className="editorial-rule w-32 mx-auto mt-10" data-id="element-208"></div>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-warm-sand-dark/30" data-id="element-209">
          {programs.map((program, index) => <StaggerItem key={index} className="bg-soft-white p-10 hover:bg-warm-sand-light transition-colors duration-500 group" data-id="element-210">
              <div className="flex items-start gap-4 mb-6" data-id="element-211">
                <div className="w-10 h-10 bg-deep-azure/5 border border-deep-azure/10 flex items-center justify-center text-deep-azure group-hover:bg-deep-azure group-hover:text-golden-yellow transition-colors duration-500 flex-shrink-0" data-id="element-212">
                  {program.icon}
                </div>
                <p className="text-[10px] font-semibold tracking-[0.25em] uppercase text-vivid-orange pt-3" data-id="element-213">
                  0{index + 1}
                </p>
              </div>
              <h3 className="text-2xl font-display font-medium text-deep-azure mb-3 tracking-tight" data-id="element-214">
                {program.title}
              </h3>
              <p className="text-sm text-charcoal-navy/70 leading-relaxed font-light" data-id="element-215">
                {program.description}
              </p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}